module.exports = __webpack_public_path__ + "static/media/5. La vida en azul, Resina cristal y metal, 37x50 cm, 2020 copy.572b49b0.png";